import { types, getParent } from 'mobx-state-tree';
import { Role } from './Roles';

export const ViewStore = types.model('ViewStore', {
  id: types.optional(types.identifier(types.string), 'viewStore'),
  roles: types.optional(types.map(Role), {}),
  currentRole: types.optional(types.reference(Role), ''),

  get currentView(): typeof Role.Type {
    return this.currentRole;
  },

  get client() {
    return getParent(this).client;
  },

  get userStore() {
    const userStore = getParent(this, 2).userStore;
    if (userStore === null || userStore === undefined) {
      return {};
    }
    return userStore;
  },
});



// WEBPACK FOOTER //
// ./~/tslint-loader!./src/common/stores/ViewStore.ts